import React from "react";
import { useTranslation } from "next-i18next";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import ourBeliefs from "../../../public/static/images/about/our_beliefs.png";
import CloudinaryImage from "../../Common/CloudinaryImage";

const OurBeliefs = () => {
  const { t } = useTranslation("about");

  return (
    <Box>
      <Box marginBottom={4}>
        <Typography
          sx={{
            textTransform: "uppercase",
            fontWeight: "medium",
          }}
          gutterBottom
          color={"textSecondary"}
          align={"center"}
        >
          {t("our_beliefs.title")}
        </Typography>
        <Box
          component={Typography}
          fontWeight={700}
          variant={"h3"}
          gutterBottom
          align={"center"}
        >
          {t("our_beliefs.subtitle")}
        </Box>
        <Typography
          variant={"h6"}
          component={"p"}
          color={"textSecondary"}
          align={"center"}
        >
          {t("our_beliefs.content")}
        </Typography>
      </Box>
      <Box
        display={"flex"}
        justifyContent={"center"}
        alignItems={"center"}
        marginBottom={4}
      >
        <Box height={"100%"} width={"100%"} maxWidth={400}>
          <CloudinaryImage
            src={ourBeliefs}
            alt={`t("our_beliefs.title") illustration`}
            height={405}
            width={433}
            layout="responsive"
            placeholder="blur"
          />
        </Box>
      </Box>
    </Box>
  );
};

export default OurBeliefs;
